module.exports = __webpack_public_path__ + "static/media/microsoft_theFactory.44a3e7dd.png";